export default __webpack_public_path__ + "static/media/blog-img219.c320c477.jpg";